import { Tooltip } from "antd";
import { FaArrowUp } from "react-icons/fa";
import React from "react";

function BalancesIndex(props) {
  console.log(props, "props in BalancesIndex");

  const suppliers = props.item.product_info.product_suppliers.filter(
    (supplier) => supplier.quantity !== null
  );

  return (
    <>
      {suppliers.map((supplier, idx) => (
        <Tooltip
          key={`product_suppliers_${supplier.id}_${idx}`}
          placement="top"
          title={
            props.disabled
              ? `Supplier ${idx + 1}`
              : supplier.supplier?.name || supplier.supplier_name
          }
        >
          <tr>
            <td style={{ whiteSpace: "nowrap" }} className="residuesItem">
              {supplier.quantity} *{" "}
            </td>
            <td className="residuesItem">
              {supplier.supplying_incomes?.map((income, index) => (
                <div key={index} className="d-flex flex-column residuesItem">
                  <div className="text-success d-flex align-items-center">
                    {income?.quantity} <FaArrowUp size={6} />
                  </div>
                </div>
              ))}
            </td>
            <td className="residuesItem">{props.item.product_reference}</td>
          </tr>
        </Tooltip>
      ))}
    </>
  );
}

export default BalancesIndex;
